module.exports = __webpack_public_path__ + "img/p14.1c25e845.png";